// extracted by mini-css-extract-plugin
export var collapsedSummary = "_my-0";